import { RefObject, useEffect, useEffectEvent } from "react";

/** This function will not trigger a render, call setState in the callback if needed */
export function useMutationObserver<T extends HTMLElement>(
	ref: RefObject<T | null | undefined>,
	onMutation: (mutations: MutationRecord[]) => void,
	options?: MutationObserverInit,
	/** Hooks cannot be run conditionally, with this boolean you can disable it */
	isDisabled?: boolean,
) {
	const onMutationEvent = useEffectEvent(onMutation);

	// Hack to prevent caller must pass a stable options object
	const optionsString = JSON.stringify(options); // to avoid eslint no-unsafe-call on options

	useEffect(() => {
		const el = ref.current;
		if (!el || isDisabled) return undefined;

		const mutationObserver: MutationObserver = new MutationObserver(
			(mutations: MutationRecord[]) => {
				onMutationEvent(mutations);
			},
		);

		mutationObserver.observe(el, JSON.parse(optionsString));

		return () => {
			mutationObserver.disconnect();
		};
	}, [ref, isDisabled, optionsString]);
}
